// extracted by mini-css-extract-plugin
export default {"selector":"InterfaceVersionSelector_selector__F+nZ7"};